export default {
  /* eslint-disable */
  getUsuario(state) {
    return state.usuario;
  },
  getEmpresasUsuario(state) {
    return state.empresas || {};
  },
  getNumeroEmpresasDisponiveis(state) {
    return Object.keys(state.empresas).length || 0;
  },
  getEmpresasSelecionadas(state) {
    if (state.empresasSelecionadas.length > 0) {
      return state.empresasSelecionadas;
    }

    return Object.keys(state.empresas) || [];
  },
  getEmpresasSelecionadasFormatadas(state, getters) {
    if (state.empresasSelecionadas.length > 0) {
      return getters.getEmpresasSelecionadasNomeCNPJ.map((empresa) => ({
        value: `${empresa.cnpj}`,
        text: `${empresa.cnpj} - ${empresa.nome}`,
      }));
    }

    return [];
  },
  getEmpresasSelecionadasNomeCNPJ(state) {
    const result = [];
    const empresas = Object.values(state.empresas);
    const especialistas = Object.values(state.especialistaOperacional);
    state.empresasSelecionadas.forEach((valor) => {
      const data = empresas.find((empresa) => empresa.id === Number(valor))
      const responsavel = especialistas.find((responsavel) => responsavel.pesCodigoEmpresa === Number(data.codigoPessoa));
      const { nome, cnpj, uf, codigoPessoa } = data;
      result.push({
        nome,
        cnpj,
        uf,
        codigoPessoa,
        responsavel,
      });
    });
    return result.sort((a, b) => (a.nome > b.nome) ? 1 : ((b.nome > a.nome) ? -1 : 0));
  },
  getTiposUsuarioOptions(state) {
    return Object.values(state.tiposUsuario).map((tipoUsuario) => {
      const tipoUsuarioFormatado = tipoUsuario.replace('_', ' ');
      return {
        text: tipoUsuarioFormatado,
        value: tipoUsuario,
      };
    });
  },
  getEspecialistaOperacional(state) {
    return state.especialistaOperacional;
  },
  isAdministrador(_, getters) {
    return getters.getUsuario.tipo === 'ADMINISTRADOR';
  },
  isAnalista(_, getters) {
    return getters.getUsuario.tipo === 'ANALISTA';
  },
  isClienteGestor(_, getters) {
    return getters.getUsuario.tipo === 'CLIENTE_GESTOR';
  },
  isCliente(_, getters) {
    return getters.getUsuario.tipo === 'CLIENTE';
  },
  isUsuarioTrust(state, getters) {
    const { getEmpresasUsuario, getUsuario } = getters;
    return getEmpresasUsuario && Object.keys(getEmpresasUsuario).length > 0 && (getUsuario.tipo !== 'CLIENTE_GESTOR' && getUsuario.tipo !== 'CLIENTE');
  },
  isTrinity(state) {
    return state.usuario.nome === 'Trinity' && state.usuario.email === 'trinity@trust.group';
  },
  getTeamTrinity(state) {
    return state.teamTrinity;
  },
  getLastFetchNotifications(state) {
    return state.lastFetchNotifications;
  },
};
